import React from 'react'
import { Row, Col} from 'antd'
import CardTotalCost from '../Cards/card-total-cost'
import TopCostUsage from '../TopCostUsage/top-cost-usage'
import DataTransferChart from './data-transfer-chart'
import './data-transfer.scss'


export default ({selectedAccount, dataTransferChartData, totalCost}) => {
    let data = new window.google.visualization.DataTable()
    let formatter = new window.google.visualization.NumberFormat({
      pattern: '$#.##',
      fractionDigits: 2
    })

    data.addColumn('string', 'Topping')
    data.addColumn('number', 'Slices')
    
    if (dataTransferChartData.length > 0)
    {
        data.addRows(dataTransferChartData)
        formatter.format(data, 1)
    }      


    dataTransferChartData && dataTransferChartData.sort((a, b) => b[1] - a[1])
    
    return (
    <div>
    <div>
        <Row type="flex" gutter={30} className="overview-container">
        <Col span={6}>
                <Row type="flex" style={{marginBottom:15}}>
                    <Col span={24}>
                        <CardTotalCost title="Total Data Transfer Cost" totalCost={totalCost} />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <TopCostUsage title="Top Costly Usage" usageTypes={dataTransferChartData.slice(0, (dataTransferChartData.length > 4 ? 4 : dataTransferChartData.length))}  />
                    </Col>
                </Row>
            </Col>

            <Col span={18}>
                <div className="overview-chart-container">
                   <DataTransferChart dataTransferChartData={data} /> 
                </div>
            </Col>
        </Row>
    </div>

    </div>
)}